export default __webpack_public_path__ + "static/media/ronpic.ba25bb2d.jpg";